<template>
    <div @click.stop class="school-list-wrap">
        <Swiper
            class="swiper-box school-list-body"
            :class="{ 'multiple': isMultiple }"
            @init="onSwiperReady"
            @slideChange="onSlideChange"
        >
            <SwiperSlide :key="item.id" v-for="item in list">
                <div class="info">
                    <div class="left">
                        <p class="name">{{ item.name }}</p>
                        <span class="tip">{{ item.type }} · {{ item.gradeRange }}</span>
                    </div>
                    <div class="right">
                        <div
                            :class="{
                                rating: true,
                                high: item.gsRating > 9,
                                middle:
                                    item.gsRating >= 6 && item.gsRating <= 9
                            }"
                        >
                            {{ item.gsRating }}
                        </div>
                        <span class="tip">{{ $t('md-house.outOf10') }}</span>
                    </div>
                </div>
                <a
                    class="link"
                    :href="link(item)"
                    target="_blank"
                    @click="clickLink(item, $event)"
                    @touchend.stop="clickLink(item, $event)"
                    rel="noopener noreferrer"
                >{{ $t('md-house.viewHomesInThisSchool') }}</a>
            </SwiperSlide>
        </Swiper>
        <div v-if="isMultiple" class="swiper-list-switch">
            <span @click.stop="swiperIns.slidePrev()" class="iconfont icon-arrow_06_left" :class="{ 'disabled': activeIndex === 0 }"></span>
            <span @click.stop="swiperIns.slideNext()" class="iconfont icon-arrow_06_right" :class="{ 'disabled': activeIndex === list.length - 1 }"></span>
        </div>
    </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from '@/common/swiper';
import { ADD_KEYWORD_MUTATION } from '@/modules/md-search/_store/config';
import { getCurrentInstance, inject, onBeforeMount, computed, ref, defineEmits } from 'vue';
import { getStore } from '@/store';
import useLng from '@/hooks/useLng';
import { buildUrl } from '@/router/index.js';

const emit = defineEmits(['mouseleave']);

let mapType = getStore('page').page?.map?.type || 'here'
const { proxy } = getCurrentInstance();
const $t = useLng('md-house');
const isListing = inject('isListing', false);
const conditionChange = inject('conditionChange', () => {});
const storeName = ref('');
const props = defineProps({
    list: {
        type: Object,
        default: () => ({})
    }
});
const isMultiple = computed(() => props.list.length > 1);
const searchStore = computed(() => getStore(storeName.value));
const link = (item) => {
    let key = item.keywordType + ':' + item.label;
    const ret =  buildUrl({ name: 'listing', query: { key: key.replace(/\+/g, ' ') } });
    return ret;
};
const clickLink = (item, event) => {
    if (isListing) {
        event.preventDefault();
        let keyword = item.name;
        if (mapType === 'here') {
            keyword =  item.addressCity && item.addressState
                ? `${item.name},${item.addressCity},${item.addressState}`
                : item.name;
        }
        searchStore.value[ADD_KEYWORD_MUTATION]({ keyword, keywordType: item.keywordType });
        conditionChange?.({
            condition: { ...searchStore.value.searchParamsWithMap },
            kee: 'key'
        });
        if (proxy.platform.isMobile) {
            //  mobile click ， retract pop up
            setTimeout(() => {
                emit('mouseleave');
            }, 200);
        }
    }
};

const swiperIns = ref(null);
const activeIndex = ref(0);
const onSwiperReady = (swiper) => {
    swiperIns.value = swiper;
}
const onSlideChange = (swiper) => {
    activeIndex.value = swiper.activeIndex;
}

onBeforeMount(() => {
    storeName.value = proxy._storeName;
});
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/components/map/css/map-common.scss';
.swiper.school-list-body {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    .swiper-slide {
        padding: 20px;
    }
    .info {
        display: flex;
        .left {
            color: var(--g-primary-color);
            width: 100%;
            .name {
                height: 42px;
                font-size: 14px;
                line-height: 21px;
                font-family: var(--font-bold);
                margin-bottom: 10px;
                @include webkitBox(2);
            }
        }
        .right {
            width: 50px;
            flex-grow: 0;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            .rating {
                width: 40px;
                height: 40px;
                line-height: 40px;
                font-size: 18px;
                text-align: center;
                border-radius: 50%;
                vertical-align: middle;
                color: var(--g-bg-color);
                margin-bottom: 12px;
                background: #77b0fd;
            }
            .tip {
                margin-top: 3px;
            }
        }
        .tip {
            font-size: 12px;
            line-height: 15px;
            color: var(--g-primary-color);
            white-space: nowrap;
        }
    }
    .link {
        display: block;
        width: 100%;
        font-size: 12px;
        font-weight: 500;
        border-radius: 2px;
        text-align: center;
        margin-top: 20px;
        padding-top: 15px;
        border-top: 1px solid rgba(218, 218, 218, 0.5);
        cursor: pointer;
        color: var(--color-link);
        & + .info {
            margin-top: 15px;
            padding-top: 15px;
            position: relative;
            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: -20px;
                right: -20px;
                height: 1px;
                background: #dcdcdc;
            }
        }
        &.novisible {
            display: none;
        }
        &:hover {
            text-decoration: underline;
        }
    }
    &.multiple {
        .swiper-slide {
            padding: 20px 20px 0 20px;
        }
        .link {
            margin-top: 0;
            padding-bottom: 15px;
            border-top: none;
            border-bottom: 1px solid rgba(218, 218, 218, 0.5);
        }
    }
}
.swiper-list-switch {
    @include swiper-list-switch();
}
</style>